import { useLanguage } from '@/contexts/LanguageContext';
import FadeIn from '@/components/FadeIn';

export default function QuemSomosSection() {
  const { t } = useLanguage();

  return (
    <section
      id="quem-somos"
      data-testid="section-quem-somos"
      className="min-h-screen flex flex-col justify-center px-8 md:px-16 lg:px-24 py-24 relative"
    >
      {/* Subtle organic shape */}
      <svg
        className="absolute top-16 right-0 w-48 h-48 opacity-[0.04] pointer-events-none"
        viewBox="0 0 200 200"
      >
        <path
          d="M100,10 C150,20 190,60 180,110 C170,160 130,195 80,185 C30,175 5,130 15,80 C25,30 50,0 100,10Z"
          fill="#F8C3A8"
        />
      </svg>

      <FadeIn>
        <h2
          data-testid="quem-somos-title"
          className="text-3xl md:text-4xl lg:text-5xl font-light text-[#873D77] tracking-tight leading-tight mb-12"
        >
          {t.quemSomos.title}
        </h2>
      </FadeIn>

      <div className="space-y-6 max-w-xl">
        {t.quemSomos.paragraphs.map((paragraph, index) => (
          <FadeIn key={index} delay={0.15 * (index + 1)}>
            <p
              data-testid={`quem-somos-p-${index}`}
              className="text-base md:text-lg font-light text-[#333333]/90 leading-relaxed"
            >
              {paragraph}
            </p>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
